import React from 'react';
import './StandardsSection.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import cvorLogo from '../../Assets/images/cvor.png';
import wsibLogo from '../../Assets/images/wsib.png';
import insuranceLogo from '../../Assets/images/insurance_permits.png';

const certifications = [
  {
    id: 'cvor',
    logo: cvorLogo,
    logoWidth: 173,
    logoHeight: 59,
    logoAlt: 'CVOR – Commercial Vehicle Operator Registration',
    label: 'MTO Safety & CVOR Certified',
  },
  {
    id: 'wsib',
    logo: wsibLogo,
    logoWidth: 162,
    logoHeight: 56,
    logoAlt: 'WSIB Ontario',
    label: 'WSIB Clearance Certificates',
  },
  {
    id: 'insurance',
    logo: insuranceLogo,
    logoWidth: 67,
    logoHeight: 67,
    logoAlt: 'Valid Insurance & Permits shield icon',
    label: 'Valid Insurance & Permits',
  },
];

const StandardsSection = () => {
  const titleRef = useAnimateOnScroll();
  const certsRef = useAnimateOnScroll();

  return (
  <section className="standards-section">
    <div className="standards-title-area">
      <h2 ref={titleRef} className="standards-title slide-down">
        Built for{' '}
        <span className="standards-title__highlight">Ontario</span>{' '}
        Standards
      </h2>
    </div>

    <div className="standards-divider" aria-hidden="true" />

    <div className="standards-certs-area">
      <div className="container">
        <div ref={certsRef} className="standards-certs slide-up">
          {certifications.map((cert) => (
            <div key={cert.id} className="standards-cert-item">
              <img
                src={cert.logo}
                alt={cert.logoAlt}
                className="standards-cert-item__logo"
                width={cert.logoWidth}
                height={cert.logoHeight}
              />
              <p className="standards-cert-item__label">{cert.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
  );
};

export default StandardsSection;
